import React from "react";
import { SchedulingToolMain } from "./schedulingTool";

const SchedulingToolPage: React.FC = () => {
    return (
        <div className="h-full w-full bg-gray-50">
            <SchedulingToolMain />
        </div>
    );
};

export default SchedulingToolPage;
